const Overlay = () => {
  return (
    <div id="overlay" className="wow fadeOut" data-wow-duration="5s" data-wow-delay="0s"></div>
  )
}

export default Overlay
